import { useState, useEffect } from 'react';
import Title from '../../components/Title';
import CustomTable from '../../components/CustomTable/CustomTable';
import { useDispatch, useSelector } from 'react-redux';
import {
    getStatistic,
    statisticLoadingStatus,
    allStatistic,
} from '../../redux/slices/statisticSlice';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';

export default function StatisticPage() {
    const dispatch = useDispatch();
    const statistic = useSelector(allStatistic);
    const statisticStatus = useSelector(statisticLoadingStatus);
    const [select, setSelect] = useState(false);

    const getTotalData = () => {
        let total = {
            key: '0',
            report_date: 'Total',
            active_users: statistic.statistic[0].active_users,
            closed_alerts: statistic.statistic[0].closed_alerts,
            new_alerts: statistic.statistic[0].new_alerts,
            users_with_alerts: statistic.usersWithAlerts,
        };
        let totalLogin = 0;
        let totalAllAlerts = 0;
        let totalSms = 0;
        let totalEmails = 0;
        let totalDeletedAccounts = 0;
        let totalNewlyCreatedAccounts = 0;
        let totalDeltaDeletedCreatedAccounts = 0;
        statistic.statistic.forEach(
            ({
                login,
                all_alerts,
                sms,
                emails,
                deleted_accounts,
                newly_created_accounts,
                delta_deleted_created_accounts,
            }) => {
                totalLogin += login;
                totalAllAlerts += all_alerts;
                totalSms += sms;
                totalEmails += emails;
                totalDeletedAccounts += deleted_accounts;
                totalNewlyCreatedAccounts += newly_created_accounts;
                totalDeltaDeletedCreatedAccounts +=
                    delta_deleted_created_accounts;
            },
        );
        total.login = totalLogin;
        total.all_alerts = totalAllAlerts;
        total.sms = totalSms;
        total.emails = totalEmails;
        total.deleted_accounts = totalDeletedAccounts;
        total.newly_created_accounts = totalNewlyCreatedAccounts;
        total.delta_deleted_created_accounts = totalDeltaDeletedCreatedAccounts;
        return total;
    };

    useEffect(() => {
        dispatch(
            getStatistic({
                from_date: '',
                to_date: '',
                client_id: '',
            }),
        );
    }, [dispatch]);

    useEffect(() => {
        setSelect({
            data: statistic.clients,
            name: 'client',
            selected_id: parseInt(statistic.client_id),
        });
    }, [statistic]);

    const onGetStatistic = async (data) => {
        try {
            await dispatch(
                getStatistic({
                    from_date: data.startDate,
                    to_date: data.endDate,
                    client_id: data.selected_id,
                }),
            ).unwrap();
        } catch (error) {
            if (error.status !== 500) {
                toast.error(error.message);
            }
        }
    };

    return (
        <div>
            <Helmet>
                <title>Console Defentry - KPI Statistic</title>
            </Helmet>
            <Title>KPI Statistic</Title>
            <div className="table-wrapper">
                <CustomTable
                    tableHeader={[
                        'Date',
                        'Login',
                        'Active users',
                        'Users with alerts',
                        'Closed Alerts (from the 1st of the month)',
                        'New Alerts (from the 1st of the month)',
                        'All alerts',
                        'Sms',
                        'Emails',
                        'Deleted accounts',
                        'Newly created accounts',
                        'Delta',
                    ]}
                    columnsDataMap={{
                        Date: 'report_date',
                        'Closed Alerts (from the 1st of the month)':
                            'closed_alerts',
                        'New Alerts (from the 1st of the month)': 'new_alerts',
                        Delta: 'delta_deleted_created_accounts',
                    }}
                    columnsWidth={{ 0: '150px', 7: '65px' }}
                    tablePannelTitle="Table of KPI Statistic"
                    topPannelButtonText="Show"
                    onAddButtonClick={onGetStatistic}
                    data={
                        statistic.statistic && statistic.statistic.length
                            ? [getTotalData(), ...statistic.statistic]
                            : []
                    }
                    isLoading={statisticStatus === 'loading'}
                    datepicker={
                        statisticStatus !== 'loading'
                            ? {
                                  from_date: statistic?.from_date,
                                  to_date: statistic?.to_date,
                              }
                            : false
                    }
                    select={select}
                />
            </div>
        </div>
    );
}
